export default "__VITE_ASSET__DW2JDhfw__"